<div class="tank-approvals-container">
  <div class="status-info">
    <div class="icon">
      <fa-icon class="base" [class.success]="approvalBussinessUnitDirector()" [icon]="icons.faShield"></fa-icon>
      <div class="centered">
        <fa-icon [icon]="approvalBussinessUnitDirector() ? icons.faCheck : icons.faXmark"></fa-icon>
      </div>
    </div>
    <span class="info">Aprobado por director de UN</span>
  </div>
  @if(roleId() === 15 && !approvalBussinessUnitDirector() && meterId()) {
    <button (click)="approve()" type="button" class="btn btn-zazz-dark ms-2 shadow-sm">Aprobar</button>
  }
  <app-modal-tank-approvals [approvalType]="'gas_meter'" (reload)="reload()" [idTank]="meterId() ?? null"></app-modal-tank-approvals>
</div>